import _extends from "@babel/runtime/helpers/extends";
import { getPremiumEssentials } from '@wix/premium-fed-sdk/@premium-essentials';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { StatusesModule } from './Statuses/StatusesModule';
import { fetchWithFallback } from '@wix/premium-fed-sdk/@apis-infra';
import { domainIsTakenHandler } from './Statuses/DomainSearchErrors';
import { entriConnectAction } from './entriConnectAction';
import { ModalsModule } from '../../ModalsExtensions';
import { urls } from '../../Navigation/urls';
import React from 'react';
import { EntriFlowStatus, parseDomain } from '@wix/domains-serverless-interface';
import { InvalidDomain } from './Statuses/DomainNameErrors/InvalidDomain';
import { DomainSearchSuiteModule } from '../../../domainSearchSuite.module';
import { Specs } from '../../Specs';
const showUpgrade = _ref => {
  let {
    domainName,
    siteName,
    msid,
    externalViewer,
    useUpgradePaywall,
    referralAdditionalInfo,
    sameTab
  } = _ref;
  const {
    upgradeRequireConnect,
    upgradePaywall,
    upgradePaywallModal
  } = ModalsModule.internals.domainsActionsModalsController;
  const {
    experiments
  } = getPremiumEssentials();
  const useUpgradePaywallModal = Boolean(experiments == null ? void 0 : experiments[Specs.UPGRADE_PAYWALL_BM]);
  const forceNewTab = Boolean(experiments == null ? void 0 : experiments[Specs.OPEN_IN_NEW_TAB_BM]) || Boolean(experiments == null ? void 0 : experiments[Specs.WIX_VIBE_OPEN_IN_NEW_TAB]) && Boolean(externalViewer);
  const modal = useUpgradePaywall && upgradePaywall || useUpgradePaywallModal && !useUpgradePaywall && upgradePaywallModal || upgradeRequireConnect;
  const useSelfTab = Boolean(sameTab) && window.self === window.top;
  const target = useSelfTab || useUpgradePaywall && !forceNewTab ? '_self' : '_blank';
  modal.show({
    domainName,
    siteName,
    primaryButtonOnClick() {
      if (!domainName || !msid) {
        return;
      }
      const url = urls.packagePickerUrl({
        domainName,
        metaSiteId: msid,
        referralAdditionalInfo
      });
      window.open(url, target);
    }
  });
};
const upgradeModalAction = params => async () => {
  showUpgrade(params);
};
export const domainSearchErrorStatuses = {
  noStatus: () => ({
    StatusComponent: () => null
  }),
  domainTakenInWix: _ref2 => {
    let {
      msid,
      siteName,
      domainName,
      t,
      externalViewer,
      fullPage,
      actionHandler
    } = _ref2;
    const {
      httpClient
    } = getPremiumEssentials();
    const canChangeOwnerReq = fetchWithFallback(DomainsApiClient.query.canChangeDomainOwner({
      httpClient: httpClient,
      request: {
        domain: domainName
      }
    }), {
      canChangeOwner: false
    });
    canChangeOwnerReq.then(() => {
      DomainsApiClient.query.domainTakenInAnotherAccountEntriEligibility({
        httpClient: httpClient,
        request: {
          domain: domainName
        }
      }).catch(() => {});
    });
    return {
      action: async () => {
        if (!msid || !siteName) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            externalViewer,
            domainName
          });
          return;
        }
        const result = await domainIsTakenHandler({
          domainName,
          msid,
          siteName,
          externalViewer,
          fullPage,
          t
        });
        if (result) {
          actionHandler == null || actionHandler({
            result,
            externalViewer,
            domainName
          });
        }
      },
      StatusComponent: StatusesModule.SDK.Components.DomainIsTaken
    };
  },
  subdomainTakenInWix: _ref3 => {
    let {
      domainName,
      msid,
      siteName,
      externalViewer,
      fullPage,
      t,
      actionHandler
    } = _ref3;
    const {
      httpClient
    } = getPremiumEssentials();
    const {
      main: rootDomain
    } = parseDomain(domainName);
    fetchWithFallback(DomainsApiClient.query.canChangeDomainOwner({
      httpClient: httpClient,
      request: {
        domain: rootDomain
      }
    }), {
      canChangeOwner: false
    }).then(() => {
      DomainsApiClient.query.domainTakenInAnotherAccountEntriEligibility({
        httpClient: httpClient,
        request: {
          domain: rootDomain
        }
      }).catch(() => {});
    });
    return {
      action: async () => {
        if (!msid || !siteName) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            externalViewer,
            domainName
          });
          return;
        }
        const result = await domainIsTakenHandler({
          domainName,
          msid,
          siteName,
          externalViewer,
          fullPage,
          t
        });
        if (result) {
          actionHandler == null || actionHandler({
            result,
            externalViewer,
            domainName
          });
        }
      },
      StatusComponent: StatusesModule.SDK.Components.SubdomainRootIsTaken
    };
  },
  subdomainRootIsConnectedByDns: _ref4 => {
    let {
      domainName,
      msid,
      siteName,
      externalViewer,
      actionHandler
    } = _ref4;
    return {
      action: async () => {
        if (!msid || !siteName) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            externalViewer,
            domainName
          });
          return;
        }
        actionHandler == null || actionHandler({
          result: EntriFlowStatus.success,
          externalViewer,
          domainName,
          assigningSiteId: msid
        });
      },
      autoInvoke: true
    };
  },
  subdomainRootIsRegistered: _ref5 => {
    let {
      domainName,
      msid,
      siteName,
      externalViewer,
      actionHandler
    } = _ref5;
    return {
      action: async () => {
        if (!msid || !siteName) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            externalViewer,
            domainName
          });
          return;
        }
        actionHandler == null || actionHandler({
          result: EntriFlowStatus.success,
          externalViewer,
          domainName,
          assigningSiteId: msid
        });
      },
      autoInvoke: true
    };
  },
  subdomainRootIsNotConnected: _ref6 => {
    let {
      domainName,
      msid,
      siteName,
      externalViewer,
      fullPage,
      t,
      actionHandler
    } = _ref6;
    return {
      action: async () => {
        if (!msid || !siteName) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            externalViewer,
            domainName
          });
          return;
        }
        const result = await entriConnectAction({
          domainName,
          msid,
          siteName,
          fullPage,
          t
        });
        if (result) {
          actionHandler == null || actionHandler({
            result: result.status,
            externalViewer,
            domainName,
            assigningSiteId: msid
          });
        }
      },
      StatusComponent: StatusesModule.SDK.Components.SubdomainRootIsTaken
    };
  },
  rootDomainIsConnectedByPointing: _ref7 => {
    let {
      domainName,
      msid,
      siteName,
      externalViewer,
      fullPage,
      t,
      actionHandler
    } = _ref7;
    return {
      action: async () => {
        if (!msid || !siteName) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            externalViewer,
            domainName
          });
          return;
        }
        const result = await entriConnectAction({
          domainName,
          msid,
          siteName,
          fullPage,
          t
        });
        if (result) {
          actionHandler == null || actionHandler({
            result: result.status,
            externalViewer,
            domainName,
            assigningSiteId: msid
          });
        }
      },
      StatusComponent: StatusesModule.SDK.Components.SubdomainRootIsTaken
    };
  },
  externalViewerConnectSubdomainNotAllowed: () => ({
    StatusComponent: StatusesModule.SDK.Components.ExternalViewerSubdomainNotAllowed
  }),
  externalViewerPurchaseSubdomainNotAllowed: () => ({
    StatusComponent: StatusesModule.SDK.Components.ExternalViewerSubdomainNotAllowed
  }),
  externalViewerAssignSubdomainNotAllowed: () => ({
    StatusComponent: StatusesModule.SDK.Components.ExternalViewerSubdomainNotAllowed
  }),
  externalViewerPointingDomain: () => ({
    StatusComponent: StatusesModule.SDK.Components.ExternalViewerPointingDomain
  }),
  notSupportedTld: _ref8 => {
    let {
      domainName
    } = _ref8;
    return {
      StatusComponent: () => {
        return /*#__PURE__*/React.createElement(InvalidDomain, {
          domainName: domainName
        });
      }
    };
  },
  notSupportedTldRegional: _ref9 => {
    let {
      domainName
    } = _ref9;
    return {
      StatusComponent: () => {
        return /*#__PURE__*/React.createElement(InvalidDomain, {
          domainName: domainName
        });
      }
    };
  },
  alreadyAssigned: _ref10 => {
    let {
      domainName,
      siteName,
      actionHandler,
      externalViewer,
      msid
    } = _ref10;
    const {
      alreadyAssigned
    } = ModalsModule.internals.domainsActionsModalsController;
    const {
      httpClient
    } = getPremiumEssentials();
    const canConnectOrBindReq = DomainsApiClient.query.canConnectOrBindDomainSuite({
      httpClient: httpClient,
      request: {
        domain: domainName,
        msid: ''
      }
    });
    return {
      action: async () => {
        var _result$assignedSite;
        const result = await canConnectOrBindReq;
        alreadyAssigned.show({
          handleClose: () => {},
          handleReassign: () => {
            alreadyAssigned.hide();
            actionHandler == null || actionHandler({
              domainName,
              assigningSiteId: msid,
              result: 'alreadyAssigned',
              externalViewer,
              siteName
            });
          },
          assignedSiteName: result == null || (_result$assignedSite = result.assignedSite) == null ? void 0 : _result$assignedSite.siteName,
          assigningSiteName: siteName,
          domain: domainName
        });
      },
      autoInvoke: true
    };
  },
  alreadyAssignedToThisSite: _ref11 => {
    let {
      actionHandler,
      externalViewer,
      msid,
      domainName,
      siteName
    } = _ref11;
    return {
      action: async () => {
        actionHandler == null || actionHandler({
          result: 'alreadyAssignedToThisSite',
          externalViewer,
          assigningSiteId: msid,
          domainName,
          siteName
        });
      },
      autoInvoke: true
    };
  },
  floatingDomain: _ref12 => {
    let {
      actionHandler,
      externalViewer,
      domainName,
      msid,
      siteName
    } = _ref12;
    return {
      action: async () => {
        actionHandler == null || actionHandler({
          result: 'floatingDomain',
          domainName,
          assigningSiteId: msid,
          externalViewer,
          siteName
        });
      },
      autoInvoke: true
    };
  },
  languageCodeSubdomain: _ref13 => {
    let {
      domainName
    } = _ref13;
    const {
      languageCodeSubdomain
    } = ModalsModule.internals.domainsActionsModalsController;
    return {
      action: async () => {
        languageCodeSubdomain.show({
          domain: domainName
        });
      },
      autoInvoke: true
    };
  },
  purchaseRootDomainIsRequired: _ref14 => {
    let {
      domainName,
      actionHandler,
      ...props
    } = _ref14;
    const {
      main
    } = parseDomain(domainName);
    const {
      formattedInput
    } = parseDomain(main);
    return {
      action: async () => {
        const {
          msid
        } = props;
        if (actionHandler) {
          await actionHandler({
            result: undefined,
            domainName: formattedInput,
            ...props
          });
          return;
        }
        const viewMode = DomainSearchSuiteModule.SDK.domainSearchSuiteStore.getStore().viewMode;
        const url = urls.getDomainUrl({
          domainName: formattedInput,
          msid,
          referralAdditionalInfo: viewMode || 'domains-gate'
        });
        window.open(url, '_self');
      },
      StatusComponent: _ref15 => {
        let {
          action
        } = _ref15;
        return /*#__PURE__*/React.createElement(StatusesModule.SDK.Components.PurchaseRootIsRequired, _extends({}, props, {
          action: action,
          domainName: formattedInput
        }));
      }
    };
  },
  upgradeRequirePurchaseSubdomain: _ref16 => {
    let {
      domainName,
      ...props
    } = _ref16;
    const {
      main
    } = parseDomain(domainName);
    const {
      formattedInput
    } = parseDomain(main);
    return {
      action: async () => {
        const viewMode = DomainSearchSuiteModule.SDK.domainSearchSuiteStore.getStore().viewMode;
        const {
          msid,
          siteName
        } = props;
        if (!msid || !siteName) {
          return;
        }
        await urls.upgradeSplitPage({
          domainName: formattedInput,
          metaSiteId: msid,
          referralAdditionalInfo: viewMode || 'domain-search-gate'
        });
      },
      StatusComponent: StatusesModule.SDK.Components.PurchaseRootIsRequired
    };
  },
  upgradeRequireAssign: _ref17 => {
    let {
      actionHandler,
      ...params
    } = _ref17;
    return {
      action: async () => {
        if (actionHandler) {
          await actionHandler({
            result: undefined,
            ...params
          });
          return;
        }
        await upgradeModalAction(params)();
      },
      autoInvoke: true
    };
  },
  upgradeRequireConnect: _ref18 => {
    let {
      actionHandler,
      ...params
    } = _ref18;
    return {
      action: async () => {
        if (actionHandler) {
          await actionHandler({
            result: undefined,
            ...params
          });
          return;
        }
        await upgradeModalAction(params)();
      },
      StatusComponent: _ref19 => {
        let {
          ...props
        } = _ref19;
        const {
          subdomain
        } = parseDomain(params.domainName);
        return subdomain ? /*#__PURE__*/React.createElement(StatusesModule.SDK.Components.SubdomainRootIsTaken, props) : /*#__PURE__*/React.createElement(StatusesModule.SDK.Components.DomainIsTaken, props);
      },
      autoInvoke: params.autoInvoke
    };
  },
  upgradeRequireTransferIn: params => ({
    action: upgradeModalAction(params),
    StatusComponent: StatusesModule.SDK.Components.DomainIsTaken,
    autoInvoke: params.autoInvoke
  }),
  upgradeRequirePurchase: _ref20 => {
    let {
      domainName,
      msid,
      actionHandler,
      ...props
    } = _ref20;
    return {
      action: async () => {
        if (!msid) {
          return;
        }
        if (actionHandler) {
          await actionHandler({
            result: undefined,
            domainName,
            msid,
            ...props
          });
          return;
        }
        const viewMode = DomainSearchSuiteModule.SDK.domainSearchSuiteStore.getStore().viewMode;
        await urls.upgradeSplitPage({
          domainName,
          metaSiteId: msid,
          referralAdditionalInfo: viewMode || 'domain-search-gate'
        });
      }
    };
  }
};
//# sourceMappingURL=domainSearchErrorStatuses.js.map